export type DistrictCatalogEntry = { name: string; schools: readonly string[] };

const PRODUCTION_DISTRICT_CATALOG: readonly DistrictCatalogEntry[] = [
  {
    name: "Slate Valley Unified",
    schools: [
      "Benson Village School",
      "Castleton Elementary School",
      "Fair Haven Grade School",
      "Fair Haven Union Middle & High School",
      "Orwell Village School",
    ],
  },
  {
    name: "Gibson County",
    schools: [
      "Dyer School",
      "Gibson Co. High School",
      "Kenton School",
      "Rutherford School",
      "South Gibson Co. Elementary School",
      "South Gibson Co. High School",
      "South Gibson Co. Middle School",
      "Spring Hill School",
      "Yorkville School",
      "GCSSD Virtual Innovation Academy",
    ],
  },
  {
    name: "Keeneyville District 20",
    schools: ["Early Childhood Center", "Greenbrook Elementary School", "Waterbury Elementary School", "Spring Wood Middle School"],
  },
];

/** Dev-only districts for `+`-address testing (e.g. cliff+district1@gmail.com). Never shipped in production. */
const DEV_DISTRICT_CATALOG: readonly DistrictCatalogEntry[] = [
  { name: "Test District 1 (district1)", schools: ["Test School D1"] },
  { name: "Test District 2 (district2)", schools: ["Test School D2"] },
  { name: "Test District 3 (district3)", schools: ["Test School D3"] },
  { name: "Test District 4 (district4)", schools: ["Test School D4"] },
];

export const DISTRICT_CATALOG: readonly DistrictCatalogEntry[] = import.meta.env.DEV
  ? [...PRODUCTION_DISTRICT_CATALOG, ...DEV_DISTRICT_CATALOG]
  : PRODUCTION_DISTRICT_CATALOG;

export function listDistrictNames(): string[] {
  return DISTRICT_CATALOG.map((d) => d.name);
}

export function schoolsForDistrict(districtName: string): string[] {
  const district = DISTRICT_CATALOG.find((d) => d.name === districtName);
  return district ? [...district.schools] : [];
}

export function isCatalogDistrict(name: string): boolean {
  return DISTRICT_CATALOG.some((d) => d.name === name);
}

export function isCatalogSchool(districtName: string, schoolName: string): boolean {
  return schoolsForDistrict(districtName).includes(schoolName);
}
